import React from 'react'

interface DropdownButtonProps {
  children: React.ReactNode
  as?: React.ElementType
  className?: string
  [key: string]: unknown
}

export default function DropdownButton({
 children, as: Component = 'button', className = '', ...props 
}: DropdownButtonProps) {
  return (
    <Component className={className} {...props}>
      {children}
    </Component>
  )
} 